import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityService } from '../../../services/security.service';
import { LoginBackgroundService } from '../../../services/login-background.service';

@Component({
  selector: 'com-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.scss'],
})
export class SetNewPasswordComponent implements OnInit {
  showErrorMessage: boolean;
  showRequestPasswordReset: boolean;
  isSuccess: boolean;
  errorMessage: string;
  setPasswordFormGroup: UntypedFormGroup;
  private token: string;
  private email: string;
  // this was added due to a complain on ng lint
  private keyToken = 'token';
  private keyEmail = 'email';

  constructor(
    route: ActivatedRoute,
    private security: SecurityService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    loginBackground: LoginBackgroundService
  ) {
    loginBackground.showLoginBackground = true;
    route.queryParams.subscribe((params) => {
      this.token = params[this.keyToken];
      this.email = params[this.keyEmail];
    });
  }

  get password() {
    return this.setPasswordFormGroup.controls.password;
  }

  get confirmPassword() {
    return this.setPasswordFormGroup.controls.confirmPassword;
  }

  ngOnInit() {
    this.showRequestPasswordReset = false;

    this.setPasswordFormGroup = this.formBuilder.group(
      {
        password: ['', [Validators.required, Validators.pattern('^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{7,}$')]],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validator: this.passwordValidator,
      }
    );

    if (!(this.token || this.email)) {
      this.security.startAuthentication();
    }
  }

  setNewPassword() {
    this.setPasswordFormGroup.markAllAsTouched();
    this.setPasswordFormGroup.markAsDirty();
    if (this.setPasswordFormGroup.valid) {
      this.showErrorMessage = false;

      const newPassword = this.setPasswordFormGroup.get('password').value;

      this.security.resetPassword(this.email, this.token, newPassword).subscribe({
        next: (result) => {
          if (result.success) {
            this.isSuccess = result.success;
            this.showErrorMessage = !this.isSuccess;
          } else {
            this.showErrorMessage = true;
            this.errorMessage = this.returnErrorMessage(result);
          }
        },
        error: (err) => {
          this.showRequestPasswordReset = true;
          this.errorMessage = `There was a problem processing your request.`;

          if (err.status === 404) {
            this.errorMessage = `The user does not exist.`;
          }

          this.showErrorMessage = true;
        },
      });
    }
  }

  returnErrorMessage(result) {
    if (result.accountLocked) {
      // eslint-disable-next-line max-len
      return `This account has been locked through too many invalid password attempts.<br />Please contact ComReg at <a href='mailto:marketdata@comreg.ie'>marketdata@comreg.ie</a>`;
    }

    if (result.tokenMismatch) {
      this.showRequestPasswordReset = true;
      return `The token is invalid or has expired.<br />(Are you sure this account has not already been activated?)<br/>`;
    }

    return `There was a problem processing your request.`;
  }

  async startLogin() {
    this.security.startAuthentication();
  }

  passwordValidator(group: UntypedFormGroup) {
    const password = group.controls.password.value;
    const passwordConfirmation = group.controls.confirmPassword.value;

    return password === passwordConfirmation ? null : { passwordsNotEqual: true };
  }

  requestPasswordReset() {
    this.router.navigateByUrl(`/accounts/password/reset?email=${this.email}`);
  }
}
